// extracted by mini-css-extract-plugin
module.exports =  {"tag":"_25d45facb5--tag--uW7FJ","tag_close":"_25d45facb5--tag_close--jS45G"};